// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3ZGsA","subheader":"ReorderModal_subheader__iMeDG","listWrap":"ReorderModal_listWrap__1Cd5E"};